import React, { Component } from "react";

/*
* Component for wrapping form fields into block
* */
const BlockFormWrapper = props => {
    return (
        <div className="card mb-3">
            <h3 className="card-header m-0 bg-gray">{props.title}</h3>
            <div className="card-block">{props.children}</div>
        </div>
    );
};

export default BlockFormWrapper;



// WEBPACK FOOTER //
// ./web/src/components/common/form/BlockFormWrapper.jsx